/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { ContentType, HttpClient, RequestParams } from "./../lib/httpClient.ts";
import {
  CreateViewDefinitionRequestDTO,
  Response,
  UpdateViewDefinitionRequestDTO,
} from "././index.d.ts";

export class Views<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * @description Get view definition by view id
   *
   * @tags uimanager
   * @name GetViewDefinition
   * @request GET:/views/{viewId}
   * @secure
   */
  getViewDefinition = (viewId: string, params: RequestParams = {}) =>
    this.http.request<Response, Response>({
      path: `/views/${viewId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Update an existing view definition
   *
   * @tags uimanager
   * @name UpdateViewDefinition
   * @request PUT:/views/{viewId}
   * @secure
   */
  updateViewDefinition = (
    viewId: string,
    data: UpdateViewDefinitionRequestDTO,
    params: RequestParams = {},
  ) =>
    this.http.request<Response, Response>({
      path: `/views/${viewId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Return all view definitions.
   *
   * @tags uimanager
   * @name ListViewDefinition
   * @request GET:/views
   * @secure
   */
  listViewDefinition = (params: RequestParams = {}) =>
    this.http.request<Response, Response>({
      path: `/views`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Create a new view definition.
   *
   * @tags uimanager
   * @name CreateViewDefinition
   * @request POST:/views
   * @secure
   */
  createViewDefinition = (
    data: CreateViewDefinitionRequestDTO,
    params: RequestParams = {},
  ) =>
    this.http.request<Response, Response>({
      path: `/views`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
}
